import React from 'react';
import { useTranslation } from 'react-i18next';
import SettingsNavigation from './SettingsAppearance';

const MeunSideSetting = ({ activeMenu, setActiveMenu }) => {
    const [t] = useTranslation('settings');
    const [tGlobal] = useTranslation('global');
    const items = [
        { id: 'Treasury', label: t('treasury.treasurysettings') },
        { id: 'account', label: t('account.accountsettings') },
        { id: 'incomes', label: t('income.incomesettings') },
        { id: 'expenses', label: t('expense.expensesettings') },
        { id: 'VatSettings', label: tGlobal('setting.vatSettings') },
    ];
    return <SettingsNavigation items={items} activeMenu={activeMenu} onSelect={item => setActiveMenu(item.id)} label={tGlobal('setting.System_Settings')} />;
};
export default MeunSideSetting;
